webpackJsonp([244446611474175],{

/***/ 569:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"date":"2018-08-29","path":"/projects/emerald-health-registration-microservice","summary":"serverless registration logic","tags":["web","bedev","es6","rest","serverless","lambda","aws","mysql","tribal"],"taskSummary":"all development","title":"Emerald Health registration microservice","url":null,"writeupDate":"2018-11-01"},"html":"<p>This is a microservice written with the <a href=\"https://serverless.com/\">Serverless Framework</a> and running on AWS Lambda.</p>\n<p>It’s an adaption of the microservice written for <a href=\"/projects/keep-canada-working\">Keep Canada Working</a> and works in much the same way.\nThe main differences are that more fields are stored, and that it was to service multiple forms and keep the responses separated based on provenance.</p>"}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-emerald-health-registration-microservice-c72bde1c9689f0a91f49.js